import angular from "angular";
import CreateOrganizationPageComponent from "./create-organization-page/create-organization-page";

const CreateOrganizationModule = angular
  .module("modules.createOrganizations", [])
  .component("createOrganizationsPage", CreateOrganizationPageComponent);

export default CreateOrganizationModule;
